import React from 'react';
import SessionLayout from '../layouts/Session/Session';
import Login from '../components/Session/Login';
import {setPageTitle, setMetaDescription} from '../utils/helpers';

const LoginPageContainer = () => {
  setPageTitle('Secure account login | Access your UK savings accounts');
  setMetaDescription('Securely access and manage your online UK savings accounts anytime. Log in now and access your Investec Save accounts.');

  return (
    <SessionLayout>
      <Login />
    </SessionLayout>
  );
};

export default LoginPageContainer;
